// src/store/index.js
import Vue from 'vue';
import db, { liveQuery } from '@/db';

const state = Vue.observable({
    keyword: '',
    loading: [true, 'Bekleyiniz'],
    aktifCari: {},
    topError: [], // bunu kullanmadık ama kullanıcaz
    notify: {
        visible: false,
        type: 'info',   // 'success' | 'danger' | 'info'
        text: ''
    }

});
let notifyTimer = null;

liveQuery(() =>
    db.caris.toCollection().filter(c => c.secili === true).first()).subscribe({
        next: cari => {
            state.aktifCari = cari || {};
        },
        error: err => {
            state.topError.push = { msg: "Query Error 1.1", detail: err }
        }
    });
export default {
    get keyword() {
        return state.keyword;
    },
    setKeyword(val) {
        state.keyword = val;
    },
    clear() {
        state.keyword = '';
    },
    setLoading(val) {
        state.loading = val;
    },
    getLoading() {
        return state.loading
    },
    get aktifCari() {
        return state.aktifCari;
    },
    setAktifCari(val) {
        state.aktifCari = val;
    },
    get notify() {
        return state.notify;
    },
    showNotify({ type = 'info', text = '', timeout = 3000 } = {}) {
        // Önce varsa eski timer’ı temizle
        if (notifyTimer) {
            clearTimeout(notifyTimer);
            notifyTimer = null;
        }

        state.notify.type = type;
        state.notify.text = text;
        state.notify.visible = true;

        // Otomatik kapanma
        if (timeout && timeout > 0) {
            notifyTimer = setTimeout(() => {
                state.notify.visible = false;
                notifyTimer = null;
            }, timeout);
        }
    },

    // NOTIFY - HIDE
    hideNotify() {
        if (notifyTimer) {
            clearTimeout(notifyTimer);
            notifyTimer = null;
        }
        state.notify.visible = false;
    }
};



// WEBPACK FOOTER //
// ./src/store/index.js